import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Succes() {
  const { clearCart } = useCart();

  useEffect(() => {
    clearCart();
  }, []);

  return (
    <div className="max-w-lg mx-auto px-5 pt-16 pb-16 text-center">
      <CheckCircle2 size={48} className="text-[#39FF14] mx-auto mb-4" />
      <h1 className="font-display font-black text-2xl md:text-3xl tracking-tight mb-3">Commande confirmée !</h1>
      <p className="text-white/60 leading-relaxed">
        Merci pour ta commande. Un email de confirmation vient de t'être envoyé par Stripe, et le Bureau de La Fribue
        prépare déjà l'expédition.
      </p>
      <Link to="/" className="btn-solid inline-flex !py-3 !px-6 mt-8">Retour à la boutique</Link>
    </div>
  );
}
